import React, { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { formatDate } from '../../utils/DateTimeUtils';
import { APP_NAME, CONTACT_US_EMAIL, CONTACT_US_PHONE, CONTACT_US_WHATSAPP_PHONE } from 'utils/Config';
import i18n from 'utils/I18n';
import CustomButton from 'component/base/CustomButton';
import { detectIsPadOrMobileByScreenWidth } from 'utils/ScreenUtils';
import './CustomerContactModal.scss';
import { CUSTOMER_SIGN_UP_METHOD } from 'utils/CustomEnums';

const callPhone = () => {
  window.location = `tel:${CONTACT_US_PHONE}`;
};

const getSendContentOfSecondContact = ({
  firstName,
  lastName,
  currentLoginContact,
  secondContact,
}) => (
`This customer provided two contacts during the sign-up process, which are associated with existing accounts. The customer wish to add the second login method.\n
Details:
First name:
${firstName || ""}\n
Last name:
${lastName || ""}\n
Contact used for sign up:
${currentLoginContact || ''}\n
Contact prvided for ‘Second login method’ (Existing account):
${secondContact || ""}`
)

const getSendText = (memberShipID) => {
  const date = formatDate(new Date(), 'DDMMYYYY');
  return `Diagnostic Code:\n ${date}_${memberShipID}_${APP_NAME}`;
};

const sendEmail = (memberShipID, customContent) => {
  const recipient = [CONTACT_US_EMAIL];
  const content = customContent || getSendText(memberShipID);
  window.location = `mailto:${recipient}?subject=&body=${encodeURIComponent(content)}`;
};

const openWhatsapp = (customContent) => {
  const whatsappUrl = `https://wa.me/${CONTACT_US_WHATSAPP_PHONE}${customContent ? `?text=${encodeURIComponent(customContent)}` : ``}`
  window.open(whatsappUrl);
}

const CustomerContactModal = ({
  userInfo,
  memberShipID,
  showCustomerContactModal,
  onClose,
}) => {
  const { show, isForSecondContact, secondContact } = showCustomerContactModal;

  const { firstName, lastName, signUpMethod, emailAddress, countryCode, phoneNumber } = userInfo;

  const currentLoginContact = useMemo(()=>{
    if (!isForSecondContact) {
      return ""
    }
    if (signUpMethod === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS ) {
      return emailAddress
    }
    if (signUpMethod === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER) {
      return `+${countryCode} ${phoneNumber}`
    }
  }, [isForSecondContact, signUpMethod, emailAddress, countryCode, phoneNumber])
  const emailOrWhatsappContent = isForSecondContact
    ? getSendContentOfSecondContact({
      firstName,
      lastName,
      currentLoginContact,
      secondContact,
    })
    : null;
  // pad or mobile size
  if (detectIsPadOrMobileByScreenWidth()) {
    return (
      <Modal
        show={show}
        onHide={onClose}
        scrollable={false}
        className={'contact-customer-service-modal'}
        centered={false}
      >
        <Modal.Body>
          <div className='contact-customer-service-background' onClick={onClose} />
          <div className='contact-customer-service-section button-large'>
            <div className='contact-customer-service-title tag-menu-1'>{i18n.t('settings_contact_customer_service_via')}</div>
            <div className='option-clickable-area'>
              <div className='contact-customer-service-option' onClick={callPhone}>{i18n.t("settings_phone")}</div>
              <div className='contact-customer-service-option' onClick={() => sendEmail(memberShipID, emailOrWhatsappContent)}>{i18n.t("settings_email")}</div>
              {
                CONTACT_US_WHATSAPP_PHONE && (
                  <div className='contact-customer-service-option' onClick={() => openWhatsapp(emailOrWhatsappContent)}>{i18n.t("settings_whatsapp")}</div>
                )
              }
            </div>
          </div>

          <div className='contact-customer-service-section button-large' onClick={onClose}>
            <div className='contact-customer-service-option'>{i18n.t("account_cancel")}</div>
          </div>
        </Modal.Body>
      </Modal >
    )
  }

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onClose}
      scrollable={false}
      className={'login-method-modal'}
      centered
    >
      <Modal.Body className={'login-method-modal-body '}>
        <div className="home-profile-custom-title title-medium-1">
          <div>
            {i18n.t('settings_contact_customer_service_via')}
          </div>
          <div className="close-icon" onClick={onClose}>
            <img
              alt="close"
              src="/profile/close.png"
              srcSet="/profile/close@2x.png 2x, /profile/close@3x.png 3x"
            />
          </div>
        </div>

        <div className="customer-contact-modal-button-container field-text">
          <ul>
            <li>
              <label onClick={callPhone}>{i18n.t("settings_phone")}</label>
            </li>
            <li>
              <label onClick={() => sendEmail(memberShipID, emailOrWhatsappContent)}>{i18n.t("settings_email")}</label>
            </li>
            {
              CONTACT_US_WHATSAPP_PHONE && (
                <li>
                  <label onClick={() => openWhatsapp(emailOrWhatsappContent)}>{i18n.t("settings_whatsapp")}</label>
                </li>
              )
            }
          </ul>

          <CustomButton
            className="button-small"
            disabled={false}
            text={i18n.t("edit_email_reminder_done")}
            btnClicked={onClose}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  memberShipID: state.users.userInfo.uid,
  userInfo: state.users.userInfo,
});

export default connect(mapStateToProps)(CustomerContactModal);
